import { Component, Input } from '@angular/core';
import { ComponentData } from '@ddt-web/data-service';

@Component({
	selector: 'dl-no-data',
	templateUrl: './no-data.component.html'
})
export class NoDataComponent {

	@Input() public data: ComponentData;

}
